import { render, staticRenderFns } from "./detailsBranchesView.vue?vue&type=template&id=321fc540&scoped=true&"
import script from "./detailsBranchesView.vue?vue&type=script&lang=js&"
export * from "./detailsBranchesView.vue?vue&type=script&lang=js&"
import style0 from "./detailsBranchesView.vue?vue&type=style&index=0&id=321fc540&prod&lang=scss&scoped=true&"
import style1 from "./detailsBranchesView.vue?vue&type=style&index=1&id=321fc540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321fc540",
  null
  
)

export default component.exports